import { ReactNode } from "react";
import { IUnit } from "../../util/varibles/interface";
import { createFastContext } from "../createFastContext";

interface IState {
    selected: { [id: string]: IUnit }
}

const {
    Provider,
    useStore: useTabBiology,
    setStore: setTabBiology,
    getStore: getTabBiology,
    callEvent: callEventTabBiology
} = createFastContext<IState>({
    selected: {},
});

const TabBiologyProvider = ({ children, ...args }: { children: ReactNode } & Partial<IState>) => {
    return <Provider props={args}>
        {children}
    </Provider>
}


export { callEventTabBiology, getTabBiology, setTabBiology, TabBiologyProvider, useTabBiology };

